module.exports = __webpack_public_path__ + "static/img/10010.6098fa9c.png";